import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MiniSpinner from '../MiniSpinner';
const AsyncActionButton = ({ isPending = false, disabled, children, withConfirm = false, className, primary = false, keepText = false, fullWidth = false, onClick, ...otherProps }) => {
    const { t } = useTranslation('shared');
    const baseClass = primary ? 'btn primary-action-btn btn-blue btn-simple' : 'btn secondary-action-btn btn-simple';
    const cls = className ? `${baseClass} ${className}` : baseClass;
    const clsConfirm = className ? `btn primary-action-btn ${className}` : 'btn alert alert-error';
    const [showConfirm, setShowConfirm] = useState(null);
    const resetButton = useCallback(() => {
        setShowConfirm(null);
    }, []);
    const onProxyClick = useCallback((e) => {
        if (withConfirm) {
            const timeoutId = setTimeout(resetButton, 3000);
            setShowConfirm(timeoutId);
        }
        else if (onClick) {
            onClick(e);
        }
    }, [onClick, resetButton, withConfirm]);
    const confirmProps = { ...otherProps, onClick };
    return (_jsxs(_Fragment, { children: [(isPending || !showConfirm) && (_jsxs("button", { style: fullWidth ? { width: '100%' } : {}, className: cls, ...otherProps, onClick: onProxyClick, disabled: isPending || disabled, children: [(!isPending || keepText) && children, isPending && _jsx(MiniSpinner, {})] })), !isPending && showConfirm && (_jsx("button", { className: clsConfirm, ...confirmProps, children: t('common.confirm') }))] }));
};
export default AsyncActionButton;
